/* eslint-disable import/prefer-default-export */
import { MDText } from 'i18n-react';

import { ENQUIRY_STATE_SLUG } from 'Utilities/constants';

import {
  CONFIRM_SALE_ALLOWED_STATUSES,
  DOCUMENT_CAPTURE_ROUTE_NAMES,
  DOCUMENT_CAPTURE_ROUTE_NAMES_ARRAY,
  VIEW_TIMELINE_STATUSES,
} from '../../../documentCapture/DocumentCapture.helpers';

import AccountTexts from './AccountPage.texts.json';

const LocalT = new MDText(AccountTexts);

const defaultActionsKey = Symbol('defaultActionsKey');

const viewSaleStatusAction = Object.freeze({
  gaEvent: 'ACCOUNT_VIEW_SALE_STATUS_BUTTON_CLICKED',
  label: LocalT.translate('viewSaleStatusLabel'),
  path: `/${DOCUMENT_CAPTURE_ROUTE_NAMES.CONFIRM_SALE}`,
});

const confirmSaleAction = Object.freeze({
  gaEvent: 'ACCOUNT_CONFIRM_SALE_BUTTON_CLICKED',
  label: LocalT.translate('confirmSaleLabel'),
  path: `/${DOCUMENT_CAPTURE_ROUTE_NAMES.CONFIRM_SALE}`,
});

const startSellingAction = Object.freeze({
  gaEvent: 'ACCOUNT_SEE_VALUATION_BUTTON_CLICKED',
  label: LocalT.translate('startYourProfile'),
  path: '',
});

const continueSellingAction = Object.freeze({
  gaEvent: 'ACCOUNT_SEE_VALUATION_BUTTON_CLICKED',
  label: LocalT.translate('continueSelling'),
  path: '',
});

const seeDealerDetailsAction = Object.freeze({
  gaEvent: 'ACCOUNT_PAGE_DEALER_INFO',
  label: LocalT.translate('viewSaleDetails'),
  path: `/${DOCUMENT_CAPTURE_ROUTE_NAMES.DEALER_DETAILS}`,
});

// Will be removed once `profileDetailsConfirmedAt` is accessible on the accounts page
const OldViewTimelineSaleStatus = Object.freeze({
  gaEvent: 'ACCOUNT_VIEW_TIMELINE_PROGRESS',
  label: LocalT.translate('viewTimelineProgress'),
  path: '',
});

const ViewTimelineSaleStatus = Object.freeze({
  gaEvent: 'ACCOUNT_VIEW_TIMELINE_PROGRESS',
  label: LocalT.translate('viewSaleStatusLabel'),
  path: '',
});

export const ACCOUNT_ACTIONS_BY_STATUS = Object.freeze({
  [CONFIRM_SALE_ALLOWED_STATUSES.SOLD_AWAITING]: confirmSaleAction,
  [CONFIRM_SALE_ALLOWED_STATUSES.SOLD_CONFIRMED]: viewSaleStatusAction,
  [CONFIRM_SALE_ALLOWED_STATUSES.SOLD_DOCUMENTS_REVIEWED]: seeDealerDetailsAction,
  [CONFIRM_SALE_ALLOWED_STATUSES.SOLD_INVOICE_RAISED]: seeDealerDetailsAction,
  [CONFIRM_SALE_ALLOWED_STATUSES.SOLD_INVOICE_PAID]: seeDealerDetailsAction,
  [VIEW_TIMELINE_STATUSES.FOR_SALE]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.FULL_DETAILS]: OldViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.FULL_DETAILS_CONTACTED]: OldViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.FULL_DETAILS_WAIT]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.QA_FAILED]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.QA_ON_HOLD]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.QA_READY]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.READY_FOR_SALE]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.SALE_ACTIVE]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.UNSOLD_BELOW_RESERVE_BID]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.UNSOLD_NO_BIDS]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.CUSTOMER_KEEP_CAR]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.CUSTOMER_LOST]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.CAR_GONE]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.TOO_EXPENSIVE]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.UNDER_OFFER]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.UNSELLABLE]: ViewTimelineSaleStatus,
  [VIEW_TIMELINE_STATUSES.WRITE_OFF]: ViewTimelineSaleStatus,
  [defaultActionsKey]: startSellingAction,
});

export const withVehicleCardPathParams = (actions, enquiryId = undefined) => (
  {
    ...actions,
    path: (
      DOCUMENT_CAPTURE_ROUTE_NAMES_ARRAY.includes(actions.path.substr(1)) && enquiryId
        ? `${actions.path}?valuation_ref=${enquiryId}`
        : actions.path
    ),
  }
);

export const generateVehicleCardActions = (status, enquiryId) => {
  let vehicleCardActions = ACCOUNT_ACTIONS_BY_STATUS[status]
    || ACCOUNT_ACTIONS_BY_STATUS[defaultActionsKey];
  if (status === ENQUIRY_STATE_SLUG.PART_DETAILS) {
    vehicleCardActions = continueSellingAction;
  }

  return withVehicleCardPathParams(vehicleCardActions, enquiryId);
};
